import React from "react";
import ContactBadges from "./ContactBadges";
import ContactIcons from "./ContactIcons";
import ContactLinks from "./ContactLinks";

const Profile = () => (
  <div className="card">
    <div className="card-image">
      <figure className="image is-1by1">
        <img src="./static/img/jean-med.jpg" alt="Jean Yeager" />
      </figure>
    </div>
    <div className="card-content">
      <p className="title is-4">Jean Yeager</p>
      <p className="subtitle is-6">The Human Story as Lived and Told</p>
      <p>
        862 Jordache Dr. <br />
        Loveland, CO 80538 <br />
        Home: (970) 908-3100 <br />
        Mobile: (734) 276-8659 <br />
        Email: <a href="mailto:jwyeager2@gmail.com">jwyeager2@gmail.com</a>
      </p>
      
      <ContactLinks />
      <ContactBadges />
      <ContactIcons />
    </div>
  </div>
);

export default Profile;
